import React, { useState, useEffect } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "bootstrap";
import {FaPlus, FaCamera, FaIdBadge, FaMoneyBillAlt, FaInfoCircle, FaFileExcel, FaPrint} from "react-icons/fa";

const getAuthToken = () => localStorage.getItem("authToken");

const StudentList = () => {
  const navigate = useNavigate();
    const [students, setStudents] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(100);
    const [offset, setOffset] = useState(0);
    const [search, setSearch] = useState("");
    const [batch, setBatch] = useState("");
    const [batches, setBatches] = useState([]);
    const [status, setStatus] = useState("Active"); // Default to Active
    const [loading, setLoading] = useState(false);
    const [admitStatus, setAdmitStatus] = useState("Admitted"); // Default to Admitted


    useEffect(() => {
        fetchStudents();
        fetchBatches();
    }, [limit, offset, search, batch, status, admitStatus]); // Added status to dependencies

    const fetchStudents = async () => {
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
        setLoading(true);
        
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}list-students`,
            {
                limit,
                offset,
                search,
                batch: batch || null,
                status: status !== "All" ? status : null, // Send status only if not "All"
                admit_status: admitStatus,
            },
            {
                headers: { Authorization: `Bearer ${token}` },
            });
            setStudents(response.data.data || null);
            setTotal(response.data.total || null);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
        setLoading(false);
    };

    const handlePrintSummary = (student_id) => {
        window.open(`/inst/student-summary-printable/${student_id}`, '_blank');

      //navigate(`/student-summary-printable/${student_id}`)
    }

    const handleFees = (id) => {
        navigate(`/fee-management/${id}`)
    }

    const fetchBatches = async () => {
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-batches`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setBatches(response.data.data);
        } catch (error) {
            console.error("Error fetching batches:", error);
        }
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setOffset(0);
    };

    const handleBatchChange = (e) => {
        setBatch(e.target.value);
        setOffset(0);
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        setOffset(0);
    };

    const handleNext = () => {
        if (offset + limit < total) setOffset(offset + limit);
    };

    const handlePrev = () => {
        if (offset - limit >= 0) setOffset(offset - limit);
    };

    const handleAdmit = async (application_no, studentIndex) => {
        if (!window.confirm("Are you sure you want to admit this student?")) return;
    
        try {
            const token = getAuthToken();
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}admit-student`,
                { application_no },
                { headers: { Authorization: `Bearer ${token}` } }
            );
    
            if (response.data.status === "success") {
                alert(`Student admitted! Admission No: ${response.data.admission_no}`);
    
                // Update state to remove the "Admit" button
                setStudents((prevStudents) => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[studentIndex].admission_no = response.data.admission_no;
                    return updatedStudents;
                });
            } else {
                alert(response.data.message);
            }
        } catch (err) {
            alert(err.response?.data?.message || "Error admitting student.");
        }
    };
    
    const handleAdmitStatusChange = (e) => {
        setAdmitStatus(e.target.value);
    };

    const handleViewSummary = (id) => {
        navigate(`/student-summary/${id}`);
    }
    
    return (
        <Layout>
            <h3>Student List <span style={{ fontSize: '0.7em' }}>({total? total : 0})</span></h3>

            
            <div className="row mb-3 align-items-center">
                {/* Search Input (Larger) */}
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by name, application no, or mobile"
                        value={search}
                        onChange={handleSearch}
                    />
                </div>

                {/* Smaller Select Dropdowns */}
                <div className="col-md-2">
                    <select className="form-control" value={batch} onChange={handleBatchChange}>
                        <option value="">All Batches</option>
                        {batches.map((b) => (
                            <option key={b.id} value={b.id}>{b.class_name + " " + b.division}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <select className="form-control" value={status} onChange={handleStatusChange}>
                        <option value="All">All</option>
                        <option value="Active">Active</option>
                        <option value="Suspend">Suspend</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <select className="form-control" value={admitStatus} onChange={handleAdmitStatusChange}>
                        <option value="All">All</option>
                        <option value="Admitted">Admitted</option>
                        <option value="Applied">Applied</option>
                    </select>
                </div>

                {/* Button Positioned at the End */}
                <div className="col-md-2 d-flex justify-content-end">
                <Link to="/create-student" className="btn btn-primary d-flex align-items-center me-2">
                    <FaPlus className="me-2" /> New
                </Link>

                <Link to="/bulk-upload-students" className="btn btn-success d-flex align-items-center">
                    <FaFileExcel className="me-2" /> Excel
                </Link>
                </div>

            </div>

            {loading ? (
                <p>Loading students...</p>
            ) : (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Sl</th>
                            <th>Ad#</th>
                            <th>Name</th>
                            <th>Batch</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.length > 0 ? (
                            students.map((student, index) => (
                                <tr 
                                    key={student.id} 
                                    onDoubleClick={() => navigate(`/student-view/${student.id}`)} 
                                    style={{ cursor: "pointer" }}
                                >
                                    <td>{index + 1}</td>
                                    <td>
                                        {student.admission_no ? (
                                            <strong className="text-success">{student.admission_no}</strong> // Highlight admission number
                                        ) : (
                                            <span className="text-muted">Apl: {student.application_no}</span> // Show application number for pending students
                                        )}
                                    </td>
                                    <td>{student.name}</td>
                                    <td>{student.batch_info || "N/A"}</td>
                                    <td>{student.mobile}</td>
                                    <td>
                                        <span className={`badge ${student.status === "Active" ? "bg-success" : "bg-danger"}`}>
                                            {student.status}
                                        </span>
                                        {student?.photo && (<>
                                            <FaCamera className="ms-2" />
                                        </>)}

                                        {student?.id_card_no && (<>
                                            <FaIdBadge className="ms-2" />
                                        </>)}
                                    </td>
                                    <td>
                                        {!student.admission_no && (
                                            <button
                                                className="btn btn-success btn-sm"
                                                onClick={() => handleAdmit(student.application_no, index)}
                                            >
                                                Admit
                                            </button>
                                        )}
                                        {student.admission_no && (
                                            <button
                                            className="btn btn-primary btn-sm me-1"
                                            onClick={() => handleFees(student.id)}
                                            title="Fees"
                                            >
                                            <FaMoneyBillAlt />
                                            </button>
                                        )}
                                        <button
                                            className="btn btn-secondary btn-sm me-1"
                                            onClick={() => handleViewSummary(student.id)}
                                            title="Summary"
                                        >
                                            <FaInfoCircle />
                                        </button>

                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePrintSummary(student.id)}
                                            title="Summary"
                                        >
                                            <FaPrint />
                                        </button>
                                        </td>
                                </tr>
                            ))
                            
                            
                            
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">No students found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
            <div className="d-flex justify-content-between">
                <button className="btn btn-secondary" onClick={handlePrev} disabled={offset === 0}>
                    &laquo; Previous
                </button>
                <button className="btn btn-secondary" onClick={handleNext} disabled={offset + limit >= total}>
                    Next &raquo;
                </button>
            </div>
        </Layout>
    );
};

export default StudentList;
